var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    transform: "translate(-1 -.5)",
    xmlns: "http://www.w3.org/2000/svg",
    width: "19pt",
    height: "19pt",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.914 16.41H4.086c-.64 0-1.16-.547-1.164-1.219V3.816c.004-.671.523-1.218 1.164-1.218h7.918a2.58 2.58 0 011.605.664l1.774 1.726c.422.446.668 1.035.695 1.66v8.54c0 .675-.52 1.222-1.164 1.222zm-9.285-.816h7.742c.211 0 .383-.18.383-.403v-4.879c0-.222-.172-.406-.383-.406H5.63c-.211 0-.383.184-.383.406v4.88c0 .222.172.402.383.402zM5.594 3.41a.395.395 0 00-.348.399v2.847a.4.4 0 00.383.407h5.031a.397.397 0 00.387-.407V3.81a.394.394 0 00-.375-.403zm4.281 2.285h.496V4.457h-.496zm0 0",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
export default __webpack_public_path__ + "static/media/icon-save.173f4fc70435d7a456a7970322477e27.svg";
export { ForwardRef as ReactComponent };